import React, { useEffect, useState } from "react";
import { useBlockLibraries } from "../../../Api/newSockets.api";
import marketplace_tab_data from "../../../assets/mockedData/marketplace_tab_data";
import MarketplaceCard from "../../../components/Cards/MarketplaceCard";
import Header from "../../../components/Header/Header";
import Tabs from "../../../components/Tabs/Tabs";
import { savePathToLocalStorage } from "../../../utils/helpers";

const BlockLibraries = () => {
  savePathToLocalStorage();
  const {
    blockLibraries,
    searchBlockLibraries,
    connected,
  } = useBlockLibraries();
  const marketplace_tabs = marketplace_tab_data;
  const [inputValue, setInputValue] = useState("");

  const filterBlockLibraries = (searchValue) => {
    setInputValue(searchValue);
  };

  useEffect(() => {
    if (!connected) return;
    searchBlockLibraries(inputValue).catch(() => {});
  }, [connected, inputValue]);

  const installedBlockLibraries = (blocks) => {
    return blocks?.filter((blockLibrary) => blockLibrary.imported);
  };
  const notInstalledBlockLibraries = (blocks) => {
    return blocks?.filter((blockLibrary) => !blockLibrary.imported);
  };

  console.log("Block libraries", blockLibraries);

  return (
    <div className="marketplace-container">
      <div className="marketplace-header-content">
        <Header
          title="Marketplace"
          // Implement searchFunction
          searchFunction={filterBlockLibraries}
        />
      </div>
      <div className="main-content-flex">
        {/* Tab navigation */}
        <Tabs data={marketplace_tabs} />
        <div className="marketplace-body-content">
          <div className="marketplace-title-container">
            <div className="marketplace-title">installed</div>
            <div
              className="marketplace-libraries"
              // style={{
              //   gridTemplateColumns:
              //     installedBlockLibraries(blockLibraries)?.length > 3 ? "" : "",
              // }}
            >
              {installedBlockLibraries(blockLibraries)?.map((data) => (
                <MarketplaceCard
                  title={data.name}
                  description={data.description}
                  author={data.creator}
                  image={data.thumbnailUrl}
                  imported={data.imported}
                  mId={data.id}
                />
              ))}
            </div>
          </div>
          <div className="marketplace-title-container">
            <div className="marketplace-title">not installed</div>
            <div
              className="marketplace-libraries"
              // style={{
              //   gridTemplateColumns:
              //     notInstalledBlockLibraries(blockLibraries)?.length < 3
              //       ? "1fr 1fr 1fr"
              //       : "",
              //   marginTop: "1rem",
              // }}
            >
              {notInstalledBlockLibraries(blockLibraries)?.map((data) => (
                <MarketplaceCard
                  title={data.name}
                  description={data.description}
                  author={data.creator}
                  image={data.thumbnailUrl}
                  imported={data.imported}
                  mId={data.id}
                />
              ))}
            </div>
          </div>
          {/* {blockLibraries?.map((data) => (
            <MarketplaceCard
              title={data.name}
              description={data.description}
              author={data.creator}
              image={data.thumbnailUrl}
              imported={data.imported}
              mId={data.id}
            />
          ))} */}
        </div>
      </div>
    </div>
  );
};

export default BlockLibraries;
